import { render } from "./AddAttribute.vue?vue&type=template&id=036fba36"
import script from "./AddAttribute.vue?vue&type=script&lang=js"
export * from "./AddAttribute.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__